import api from "../api";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import AuthCard from "./authCard";
import { accountInitSchema } from "./validation";
import { yupResolver } from "@hookform/resolvers/yup";


function FirstConnexion() {
  const methods = useForm({
      resolver: yupResolver(accountInitSchema),
    });
  const { register, handleSubmit, formState:{errors} } = methods;
  const [status, setStatus] = useState("");

  const onSubmit = async (data) => {
    setStatus("");
    try {
      await api.post("/events/sendInitLink", { email: data.email });
      setStatus("Un email d'initialisation a été envoyé si ce compte existe.");
    } catch (err) {
      setStatus("Erreur lors de l'envoi du lien. Vérifiez l'adresse ou réessayez plus tard.");
    }
  };

  return (
    <AuthCard>
          <Typography variant="h5" align="center" gutterBottom>
            Première connexion
          </Typography>
          <Typography
            variant="body1"
            align="center"
            color="textSecondary"
            gutterBottom
          >
            Saisissez votre adresse email pour recevoir le lien d'initialisation.
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Adresse email"
                  fullWidth
                  {...register("email", { required: true })}
                  type="email"
                  autoFocus
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : ""}
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary" fullWidth>
                  Recevoir le lien d'initialisation
                </Button>
              </Grid>
              <Grid item xs={12}>
                {status && (
                  <Typography
                    align="center"
                    color={status.startsWith("Erreur") ? "error" : "success.main"}
                    sx={{ mt: 1 }}
                  >
                    {status}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </form>
    </AuthCard>
  );
}

export default FirstConnexion;
